export default "__VITE_ASSET__DTRdJq2B__"